const UnitOfMeasure = {
  METRIC: "Metric",
  IMPERIAL: "Imperial",
};

export default UnitOfMeasure;
